import { useState } from "react";
import UploaderSideBarOptions from "./UploaderSideBarOptions";
import Button from "components/Elements/Button/Button";
import Icon from "components/Elements/Icon/Icon";
import loader from "helpers/loaderUrl";
import Image from "components/Elements/Image/Image";
import { useContent } from "contexts/contentContext/contentContext";
import { useUploader } from "contexts/uploaderContext/uploaderContext";
import { IFormBody } from "../../models/models";
import useMediaQueries from "hooks/useMediaQueries";

interface IUploaderSideBarOptions {
  sideOptions: string[];
  swapFormFunction: (option: string) => void;
  currentOption: string;
  hideJumbopay: boolean;
  collapsed: boolean;
  handleSubmit: (body: IFormBody) => void;
  body: any;
}

const UploaderButtons = ({
  sideOptions,
  swapFormFunction,
  currentOption,
  hideJumbopay,
  handleSubmit,
  collapsed,
  body,
}: IUploaderSideBarOptions) => {
  const { getUploading, getHideSubmit, getMailId } = useUploader();
  const { getTextByKey } = useContent();
  const [loading, setLoading] = useState(false);
  const { mobileCondition } = useMediaQueries();

  const conditionHideSendButton = !getMailId() || getHideSubmit();

  const submitAction = async () => {
    if (collapsed) {
      swapFormFunction("send-plane");
    } else {
      setLoading(true);
      await handleSubmit(body);
      setLoading(false);
    }
  };

  return (
    <div
      className={`home-upload-buttons${
        conditionHideSendButton ? " no-submit" : ""
      }`}
    >
      {mobileCondition ? null : (
        <UploaderSideBarOptions
          sideOptions={sideOptions}
          swapFormFunction={swapFormFunction}
          currentOption={currentOption}
          hideJumbopay={hideJumbopay}
        />
      )}
      {conditionHideSendButton ? null : (
        <Button
          onClick={submitAction}
          disabled={loading}
          buttonClass="submit-form-button"
        >
          {loading ? (
            <Image src={loader} />
          ) : collapsed ? (
            <Icon name="arrow-back" white />
          ) : (
            getTextByKey(getUploading() ? "update-details" : "send-files")
          )}
        </Button>
      )}
    </div>
  );
};

export default UploaderButtons;
